const validate = values => {
  const errors = {};
  if (!values.description) {
    errors.description = 'Favor informar a descrição do motivo de devolução! ';
  }
  return errors;
};

export default validate;
